import { useRef, useState } from "react";
import { Loader2 } from "lucide-react";
import MessageDialog from "../../../components/ui/dialog/MessageDialog";
import { mensagemDeErro } from "../hooks";
import { ACOES, descrever } from "../status";

const MINIMO = 15;
const MAXIMO = 255;

export default function DialogoJustificativa({ pedido, onConfirmar, onDesistir }) {
	const campo = useRef(null);
	const [texto, setTexto] = useState("");
	const [erro, setErro] = useState("");
	const [enviando, setEnviando] = useState(false);
	const tamanho = texto.trim().length;

	function falhar(mensagem) {
		setErro(mensagem);
		setEnviando(false);
		campo.current.focus();
	}

	async function confirmar() {
		if (enviando) return;
		if (tamanho < MINIMO) return falhar(`Informe ao menos ${MINIMO} caracteres.`);

		setErro("");
		setEnviando(true);
		try {
			await onConfirmar(texto.trim());
		} catch (e) {
			falhar(mensagemDeErro(e));
		}
	}

	return (
		<MessageDialog
			open
			variant="warning"
			buttons="confirmCancel"
			autoFocus={null}
			onAfterOpen={() => campo.current.focus()}
			title={`${ACOES[pedido.acao].rotulo} ${descrever(pedido.item)}`}
			description={
				<div className="flex flex-col gap-2">
					<p className="mb-0">
						{pedido.simulado
							? "Simulação: nada será enviado à SEFAZ."
							: "O pedido vai para a SEFAZ e não pode ser desfeito."}
					</p>
					<label className="text-xs font-medium text-gray-500 mb-0">Justificativa</label>
					<textarea
						ref={campo}
						rows={3}
						value={texto}
						maxLength={MAXIMO}
						readOnly={enviando}
						onChange={(e) => setTexto(e.target.value)}
						onKeyDown={(e) => e.key !== "Enter" && e.stopPropagation()}
						className="border border-gray-300 rounded px-3 py-2 text-sm w-full read-only:bg-gray-50"
					/>
					<div className="flex justify-between gap-3 text-xs">
						<span className="text-red-600">{erro}</span>
						<span className="text-gray-400 shrink-0">
							{tamanho} de {MINIMO} a {MAXIMO}
						</span>
					</div>
					{enviando && (
						<div className="flex items-center gap-2 text-sm text-gray-600">
							<Loader2 size={14} className="animate-spin" />
							Enviando à SEFAZ...
						</div>
					)}
				</div>
			}
			onConfirm={confirmar}
			onCancel={enviando ? undefined : onDesistir}
		/>
	);
}
